import { clearErrors, handleErrors } from './ErrorActions';
import * as savedSearchesApi from '../api/saved-searches';
import { ERROR_SOURCES } from '../constants/ErrorsConstants';
import { parseHtmlToText } from '../utils/domUtils';

export const GET_SAVED_SEARCH_RESULTS = 'GET_SAVED_SEARCH_RESULTS';
export const GET_SAVED_SEARCH_RESULTS_SUCCESS = 'GET_SAVED_SEARCH_RESULTS_SUCCESS';
export const GET_SAVED_SEARCH_RESULTS_FAILURE = 'GET_SAVED_SEARCH_RESULTS_FAILURE';
export const SET_CURRENT_ENTITY_VIEW_NAME = 'SET_CURRENT_ENTITY_VIEW_NAME';
export const SET_CURRENT_SAVED_SEARCH_NAME = 'SET_CURRENT_SAVED_SEARCH_NAME';

export const searchErrorsFilter = ({ source }) => source !== ERROR_SOURCES.SAVED_SEARCH;

export const setCurrentEntityViewName = (entityName) => ({
  type: SET_CURRENT_ENTITY_VIEW_NAME,
  payload: entityName,
});

export const setCurrentSearchName = (searchName) => ({
  type: SET_CURRENT_SAVED_SEARCH_NAME,
  payload: searchName,
});

export const getSavedSearchResultsSuccess = (entityName, searchName, dataKey, results) => ({
  type: GET_SAVED_SEARCH_RESULTS_SUCCESS,
  payload: {
    entityName,
    searchName,
    dataKey,
    results,
  },
});

export const getSavedSearchResultsFailure = (entityName, searchName, dataKey, error) => ({
  type: GET_SAVED_SEARCH_RESULTS_FAILURE,
  payload: {
    entityName,
    searchName,
    dataKey,
    error,
  },
});

export const getSavedSearchResults = (savedSearch, customEndpointName) => async (dispatch) => {
  const { entityName, searchName, dataKey } = savedSearch;

  dispatch(clearErrors(searchErrorsFilter));
  try {
    dispatch({
      type: GET_SAVED_SEARCH_RESULTS,
      payload: {
        ...savedSearch,
      },
    });

    const apiData = await savedSearchesApi.getSavedSearchResults(savedSearch, customEndpointName);

    if (apiData.hasError) {
      dispatch(
        handleErrors(apiData.errors, { source: ERROR_SOURCES.SAVED_SEARCH, isTopBanner: true })
      );
      dispatch(getSavedSearchResultsFailure(entityName, searchName, dataKey, apiData.errors));
    } else {
      const rows = Array.isArray(apiData.SearchData.rows)
        ? apiData.SearchData.rows.map(parseRow)
        : apiData.SearchData.rows;

      dispatch(setCurrentEntityViewName(apiData.SearchData.viewName));
      dispatch(setCurrentSearchName(searchName));
      dispatch(
        getSavedSearchResultsSuccess(entityName, searchName, dataKey, {
          ...apiData.SearchData,
          rows,
        })
      );
    }
  } catch (error) {
    dispatch(handleErrors(error));
    dispatch(getSavedSearchResultsFailure(entityName, searchName, dataKey, error));
  }
};

export function parseRow(obj) {
  return Object.entries(obj).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: parseHtmlToText(value) }),
    {}
  );
}
